import FormComponents from "components/forms/FormComponents";
import { Icon, Modal } from "enums";
import manager from "managers/app";
import { DeepDungeonsModalProps } from "modals/content/deep-dungeons/types";
import ModalContent from "modals/content/ModalContent";
import ModalFooter from "modals/footer/ModalFooter";
import ModalHeader from "modals/header/ModalHeader";
import { Component } from "react";
import { connect } from "react-redux";
import t from "translations/translator";
import { AppState } from "types/app";
import "./DeepDungeonsModal.css";

const mapStateToProps = (state:AppState):DeepDungeonsModalProps.Redux => {
	return {
		lang: state.userInfo.options.lang,
		gameLang: state.userInfo.options.gameLang,
		deepDungeons: state.modal[Modal.DEEP_DUNGEON],
	};
};

class DeepDungeonsModal extends Component<DeepDungeonsModalProps.Component> {
	render():JSX.Element{
		return (
			<div id={Modal.DEEP_DUNGEON} className="modal-wrapper">
				<ModalHeader text="Deep Dungeons" icon={Icon.DUNGEON} />
				<ModalContent>
					<div className="deep-dungeon-wrapper">
						{this.props.deepDungeons.map((deepDungeon) => {
							return <div key={deepDungeon} className="deep-dungeon-card">
								<h3 className="deep-dungeon-name">{t.t(deepDungeon)}</h3>
							</div>;
						})}
					</div>
				</ModalContent>
				<ModalFooter>
					<FormComponents.Button text="Close" onClick={manager.modal.close} translate={true} />
				</ModalFooter>
			</div>
		);
	}
}
export default connect(mapStateToProps)(DeepDungeonsModal);
